import React from 'react';
import { withTranslation } from 'react-i18next';

import { formatDateTime } from '@sophocles/utils/formatUtils';

/**
 * Component Notes:
 * uses date_start and date_end query params for state
 * */
class PowerList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { list, t } = this.props;
    const rowCount = list.size; // after filter

    const filterString = t('powerData.displayingRecords', 'Displaying: {{count}} Records', { count: rowCount });

    return (
      <div className="" style={{ height: '100%' }}>
        <div style={{ height: 'calc(100% - 20px)', overflow: 'scroll' }}>
          {list.map(reading => (
            <div key={reading.get('id')} style={{ margin: '12px 8px', borderBottom: '1px solid var(--divider-color)' }}>
              <div>{formatDateTime(reading.get('moment'))}</div>
              <div>
                {t('powerData.energyConsumedKwh', 'Energy Consumed (kWh)')} {reading.get('consumed')}
              </div>
              <div>
                {t('powerData.energyGeneratedKwh', 'Energy Generated (kWh)')} {reading.get('generated')}
              </div>
              <div>
                {t('powerData.netEnergyKwh', 'Net Energy (kWh)')} {reading.get('net')}
              </div>
            </div>
          ))}
        </div>
        <div>
          <span style={{ fontSize: '12px' }}>{filterString}</span>
        </div>
      </div>
    );
  }
}

export default withTranslation()(PowerList);
